import os from 'os';
import path from 'path';
import { readUserPreferences } from './readUserPreferences.js';

/**
 * Get the cache path from user preferences if set.
 * Falls back to the default cache path `~/.cloudpack`.
 *
 * NOTE: If a session object is available, you should use `session.cachePath` instead.
 *
 * @param overridePath If set, this path (probably from a CLI option) will be used instead
 * of the path from preferences.
 * @returns An absolute path to the cache directory. Relative paths are resolved against cwd.
 */
export async function getCachePath(overridePath?: string): Promise<string> {
  const cachePath = overridePath || (await readUserPreferences())?.cachePath || path.join(os.homedir(), '.cloudpack');
  // Always resolve to absolute path for consistent behavior across all consumers
  return path.resolve(cachePath);
}

/**
 * Gets the path to the app's local cache directory.
 */
export function getLocalCachePath(appPath: string): string {
  return path.join(appPath, 'node_modules', '.cache', 'cloudpack');
}
